<style type="text/css" lang="scss" scoped>
	@keyframes popup-show {
	    0%{
	        opacity: 0.7;
	        transform: scale(0.8);
	    }
	    50%{
	        transform: scale(1.1);
	    }
	    100%{
	        opacity: 1;
	        transform: scale(1.0);
	    }
	}
	#popupMeng{
		width:100%;
		height:100%;
		background-color: rgba(34,34,34,0.50);
		position:fixed;
		z-index:1002;
		top:0;
		left:0;
		.popup {
		    position: fixed;
		    z-index: 100;
		    left: 50%;
		    top: 50%;
		    background: #fff;
		    transition: all .3s;
		    transform:scale(0.7);
		    // display:none;
			padding:20px 30px 30px 30px;
			border-radius:5px;
		    &.popup-show {
		        animation: popup-show .3s linear;
		        display:block;
		        transform:scale(1);
		    }
		    .popTitle{
		    	font-size:18px;
		    	color:#222;
		    	line-height:18px;
		    	span {
		            &.close {
		                position: absolute;
		                right: 10px;
		                top: 15px;
		                width: 26px;
		                height: 26px;
		                line-height: 26px;
		                text-align: center;
		                cursor: pointer;
		                color: #bbbbbb;
		                border-radius: 13px;
		                &:before, &:after {
		                    position: absolute;
		                    width: 18px;
		                    height: 2px;
		                    background-color: #bbbbbb;
		                    content: '';
		                    left: 4px;
		                }
		                &:before {
		                    top: 13px;
		                    transform: rotate(45deg);
		                }
		                &:after {
		                    bottom: 11px;
		                    transform: rotate(-45deg);
		                }
		            }
		        }
		    }
		    .popBtnBox{
		    	height:34px;
		    	margin:0 auto;
		    	position:relative;
		    	input{
		    		height:34px;
		    		border:none;
		    		border-radius:5px;
		    		color:#fff;
		    		cursor:pointer;
		    		&.popBtn1{
						width:40%;
		    			background-color: #ff7043;
		    			margin-left:2%;
		    			margin-right:15%;
		    		}
		    		&.popBtn2{
						width:40%;
		    			background-color: #b7b7b7;
		    		}
		    		&.popBtn3{
		    			background-color: #ff7043;
						width:80%;
		    		}
		    	}
		    }
		}
	}
</style>

<template>
	<div id="popupMeng">
		<!-- 是否自定义 -->
		<div class="popup" :style="popupStyle" v-if="isDefault">
			<p class="popTitle" v-if="showTitle">{{title}}<span class="close" v-if="showClose" v-on:click="closePop"></span></p>
			<slot></slot>
			<div class="popBtnBox" v-if="showPopBtn">
				<input type="button" class="popBtn1" v-bind:value="popBtns[0]" v-if="popBtns.length>1" v-on:click="onOk">
				<input type="button" class="popBtn2" v-bind:value="popBtns[1]" v-if="popBtns.length>1" v-on:click="onCancle">
				<input type="button" class="popBtn3" v-bind:value="popBtns[0]" v-if="popBtns.length==1" v-on:click="onOk">
			</div>
		</div>

		<slot v-if="!isDefault"></slot>

	</div>
</template>

<script type="text/javascript">

	module.exports = Vue.component('popup',{
		data:function(){
			return {

			}
		},
		props:{
			isDefault:{
				type:Boolean,
				default:true,               //是否为默认样式
			},
			showTitle:{					   // 是否显示标题
				type:Boolean,
				default:true,
			},
			title:{						   // 弹窗标题
				type:[String,Number],
				default:'提示',
			},
			showClose:{					   // 是否显示右上角关闭按钮，默认显示
				type:Boolean,
				default:true,
			},
			showPopBtn:{				   // 是否显示底部按钮，默认显示
				type:Boolean,
				default:true,
			},
			popBtns:{
				type:Array,
				default:['确定','取消'],   // 按钮 value 值，默认为两个按钮，分别为 “确定”、“取消”
			},	// 对于按钮，第一个始终执行 onOk(是) 操作，第二个始终执行 onCancle(否) 操作；只有一个按钮时按钮执行 confirm 操作
			popupStyle:{
				type: Object,
				default:{}
			}

		},
		mounted:function(){
			this.$nextTick(function(){
				// 弹窗大小和位置控制
				let marLeft = -parseInt($('.popup').css('width'))*0.5 + 'px';
				let marTop  = -parseInt($('.popup').css('height'))*0.7 + 'px';
				$('.popup').css({
					marginLeft:marLeft,
					marginTop:marTop,
				})
				// 添加动画
				setTimeout(function(){
					$('.popup').addClass('popup-show');
				});
			})
		},
		methods:{
			closePop:function(){
				this.$emit('popClose');      // 取消或关闭按钮回调
			},
			onOk:function(){
				this.$emit('popConfirm');    // 确认按钮回调
			},
			onCancle:function(){
				this.closePop();
			}
		}
	})
</script>



// WEBPACK FOOTER //
// src/components/common/popup/popup.vue